import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './EQAPP_Legal_Rights_Matrix.css';

const EQAPP_Legal_Rights_Matrix = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"EQAPP_LEGAL_RIGHTS_MATRIX",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	EQAPP_LEGAL_RIGHTS_MATRIX:-1
  });


  const [EQAPP_LEGAL_RIGHTS_MATRIX, setEQAPP_LEGAL_RIGHTS_MATRIX] = React.useState(null);
  const [EQAPP_LEGAL_RIGHTS_MATRIX_D, setEQAPP_LEGAL_RIGHTS_MATRIX_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Equity Appreciation Token Legal Rights Matrix');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewEQAPP_LEGAL_RIGHTS_MATRIX(clientInfo,"OpenNew");

		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewEQAPP_LEGAL_RIGHTS_MATRIX(clientInfo,"OpenNew");
		}
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
		if(Temp_Data2.status!="New"){
			handleDeleteEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data2);
			navigate('/EQAPP_Legal_Rights_Matrix#New',{replace:true});
		} 
		else 
			navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Legal_Rights_Matrix',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!EQAPP_LEGAL_RIGHTS_MATRIX) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_${i}_SECTION`;
	  const headerId = `#EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [EQAPP_LEGAL_RIGHTS_MATRIX]) ;


  
  
  var Ids = [];
  for(var Ele in EQAPP_LEGAL_RIGHTS_MATRIX){
	  for(var Sec in EQAPP_LEGAL_RIGHTS_MATRIX[Ele]){
		if(Sec == "id")
			Ids.push(EQAPP_LEGAL_RIGHTS_MATRIX[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(EQAPP_LEGAL_RIGHTS_MATRIX[Ele]["status"]);
		else if(Array.isArray(EQAPP_LEGAL_RIGHTS_MATRIX[Ele][Sec]))
			  for(var Row in EQAPP_LEGAL_RIGHTS_MATRIX[Ele][Sec])  // Convert to EQAPP_LEGAL_RIGHTS_MATRIX[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in EQAPP_LEGAL_RIGHTS_MATRIX[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["EQAPP_LEGAL_RIGHTS_MATRIX"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewEQAPP_LEGAL_RIGHTS_MATRIX(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX`).then((response1) => {
		if(!EQAPP_LEGAL_RIGHTS_MATRIX) 
			setEQAPP_LEGAL_RIGHTS_MATRIX(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX_D`).then((response2) => {
			setEQAPP_LEGAL_RIGHTS_MATRIX_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddEQAPP_LEGAL_RIGHTS_MATRIX_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewEQAPP_LEGAL_RIGHTS_MATRIX = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setEQAPP_LEGAL_RIGHTS_MATRIX(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutEQAPP_LEGAL_RIGHTS_MATRIX = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostEQAPP_LEGAL_RIGHTS_MATRIX = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteEQAPP_LEGAL_RIGHTS_MATRIX = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_LEGAL_RIGHTS_MATRIX', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["1"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["1"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["1"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["1"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3"]=value;
	Form_Data_onChange("1","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 
  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["1"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4"]=value;
	Form_Data_onChange("1","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 
  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["4"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0"]=value;
	Form_Data_onChange("4","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 
  

    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["5"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["9"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0"]=value;
	Form_Data_onChange("9","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 
  

    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["9"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["9"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["9"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["9"]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4"]=value;
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4",value,Temp_Data);
 	//handleLastDataEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));  
  Temp_Data['2'][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0"] = value;
  setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
};

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["2"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["2"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["2"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["2"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["2"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 



const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));  
  Temp_Data['3'][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0"] = value;
  setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
};

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 

  


const EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
	Temp_Data["3"][index]["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6"]=value ? true : false;
    setEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data);
	//handleAddEQAPP_LEGAL_RIGHTS_MATRIX(Temp_Data,App_Data['EQAPP_LEGAL_RIGHTS_MATRIX']);
  }; 




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!EQAPP_LEGAL_RIGHTS_MATRIX) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5']='';
	    break;
	  case('3'):
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5']='';
	    newRow['EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6']='';
	    break;

  }


  const updatedEQAPP_LEGAL_RIGHTS_MATRIX =JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
  updatedEQAPP_LEGAL_RIGHTS_MATRIX[Sec] = [...updatedEQAPP_LEGAL_RIGHTS_MATRIX[Sec], newRow];
  setEQAPP_LEGAL_RIGHTS_MATRIX(updatedEQAPP_LEGAL_RIGHTS_MATRIX);
};

const handleDeleteRow = (sec,index) => {
  const updatedEQAPP_LEGAL_RIGHTS_MATRIX = JSON.parse(JSON.stringify(EQAPP_LEGAL_RIGHTS_MATRIX));
  updatedEQAPP_LEGAL_RIGHTS_MATRIX[sec].splice(index, 1);
  setEQAPP_LEGAL_RIGHTS_MATRIX(updatedEQAPP_LEGAL_RIGHTS_MATRIX);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Equity Appreciation Token Legal Rights Matrix`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Equity Appreciation Token Rights Matrix ID`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`EQAPP Rights Matrix ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0" type="text" className="form-control" placeholder="EQAPP Rights Matrix ID" value={EQAPP_LEGAL_RIGHTS_MATRIX["1"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter EQAPP Rights Matrix ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1" type="text" className="form-control" placeholder="Offering ID" value={EQAPP_LEGAL_RIGHTS_MATRIX["1"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2" type="text" className="form-control" placeholder="Token Class ID" value={EQAPP_LEGAL_RIGHTS_MATRIX["1"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Token Class ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Economic Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3"  value={EQAPP_LEGAL_RIGHTS_MATRIX["1"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3`]} onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_3_Change} className="form-control" name="Token Economic Model"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Pre-Auction Conditional Pool">Pre-Auction Conditional Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Economic Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Ownership Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4"  value={EQAPP_LEGAL_RIGHTS_MATRIX["1"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4`]} onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_1_4_Change} className="form-control" name="Token Ownership Model"  >
						  <option value="No Direct Ownership / Economic Right Only">No Direct Ownership / Economic Right Only</option>
						  <option value="Revenue Participation Right">Revenue Participation Right</option>
						  <option value="Sale Proceeds Participation">Sale Proceeds Participation</option>
						  <option value="Equity Appreciation Participation">Equity Appreciation Participation</option>
						  <option value="Preferred Equity Interest">Preferred Equity Interest</option>
						  <option value="Common Equity Ownership Percentage">Common Equity Ownership Percentage</option>
						  <option value="Debt / Note Holder Claim">Debt / Note Holder Claim</option>
						  <option value="Hybrid Economic Rights">Hybrid Economic Rights</option>
						  <option value="Conditional Auction Pool Right">Conditional Auction Pool Right</option>
						  <option value="Post-Auction Asset Economic Right">Post-Auction Asset Economic Right</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Ownership Model
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_HEADER">{t(`Legal Right Group`)} <span className="toggle-icon">^</span></h2>
            <div  id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Legal Right Group`)}</th>
                        <th>{t(`Ownership Right`)}</th>
                        <th>{t(`Rental Income Right`)}</th>
                        <th>{t(`Revenue Share Right`)}</th>
                        <th>{t(`Sale Profit Right`)}</th>
                        <th>{t(`Equity Appreciation Right`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {EQAPP_LEGAL_RIGHTS_MATRIX['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0`]} data-search={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0"  onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0_Change(ev, i)}  className="form-control" value={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_0`]} name="Legal Right Group">
						  <option value="Ownership Rights">Ownership Rights</option>
						  <option value="Income Rights">Income Rights</option>
						  <option value="Voting Rights">Voting Rights</option>
						  <option value="Information Rights">Information Rights</option>
						  <option value="Transfer Rights">Transfer Rights</option>
						  <option value="Redemption Rights">Redemption Rights</option>
						  <option value="Liquidation Rights">Liquidation Rights</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_1`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_3`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_4`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_2_5`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_HEADER">{t(`Legal Right Group`)} <span className="toggle-icon">^</span></h2>
            <div  id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Legal Right Group`)}</th>
                        <th>{t(`Debt Interest Right`)}</th>
                        <th>{t(`Preferred Return Right`)}</th>
                        <th>{t(`Voting Right`)}</th>
                        <th>{t(`Information Right`)}</th>
                        <th>{t(`Redemption Right`)}</th>
                        <th>{t(`Transfer Right`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {EQAPP_LEGAL_RIGHTS_MATRIX['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0`]} data-search={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0"  onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0_Change(ev, i)}  className="form-control" value={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_0`]} name="Legal Right Group">
						  <option value="Ownership Rights">Ownership Rights</option>
						  <option value="Income Rights">Income Rights</option>
						  <option value="Voting Rights">Voting Rights</option>
						  <option value="Information Rights">Information Rights</option>
						  <option value="Transfer Rights">Transfer Rights</option>
						  <option value="Redemption Rights">Redemption Rights</option>
						  <option value="Liquidation Rights">Liquidation Rights</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_1`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_3`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_4`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_5`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6_Change(ev, i)} 
								  checked={e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6`]  === true? e[`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_3_6`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Liquidation Priority`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Liquidation Priority`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0"  value={EQAPP_LEGAL_RIGHTS_MATRIX["4"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0`]} onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_4_0_Change} className="form-control" name="Liquidation Priority"  >
						  <option value="Senior Debt">Senior Debt</option>
						  <option value="Preferred Equity">Preferred Equity</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Pro Rata">Pro Rata</option>
						  <option value="Subordinated">Subordinated</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Liquidation Priority
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Restrictions Text`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Restrictions Text`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0" type="text" className="form-control" placeholder="Restrictions Text" value={EQAPP_LEGAL_RIGHTS_MATRIX["5"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Restrictions Text`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0"  value={EQAPP_LEGAL_RIGHTS_MATRIX["9"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0`]} onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1" type="text" className="form-control" placeholder="Created By" value={EQAPP_LEGAL_RIGHTS_MATRIX["9"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2" type="text" className="form-control" placeholder="Created At" value={EQAPP_LEGAL_RIGHTS_MATRIX["9"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3" type="text" className="form-control" placeholder="Updated By" value={EQAPP_LEGAL_RIGHTS_MATRIX["9"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4" type="text" className="form-control" placeholder="Updated At" value={EQAPP_LEGAL_RIGHTS_MATRIX["9"][`EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4`]} 
						onChange={EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_02_OFFERING_NAV_LEGAL_COMPLIANCE_READINESS_EQAPP_LEGAL_RIGHTS_MATRIX_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default EQAPP_Legal_Rights_Matrix;  